import React from 'react';
import { Link } from 'react-router-dom';
import store from 'redux/store';
import { divisionNumber } from 'untils/auth';
import dayjs from 'untils/dateTime/day';
import Highlighted from './Highlight';
const BlogList = ({ blogList, searchValue }) => {
  return (
    <>
      {blogList?.map((item) => {
        return (
          <li key={item.blogId}>
            <Link to={`/blog/${encodeURIComponent(`${item.url || item.blogId}`)}`}>
              <div className="img">
                <img
                  src={`${process.env.REACT_APP_RESOURCE_URL}/${item.image}`}
                  alt="blog propaganda"
                />
              </div>
              <div className="blog-text">
                <h3 className="title">
                  <Highlighted
                    text={item.title}
                    highlight={searchValue || store.getState().getBlogSearchkeyword}
                  />
                </h3>

                <Highlighted
                  text={item.describe}
                  highlight={searchValue || store.getState().getBlogSearchkeyword}
                  regularTag={'p'}
                  className="describe"
                />

                <div className="date">
                  <span>{dayjs(item.date).format('MMM DD, YYYY')}</span>
                  <span>{divisionNumber(item.views || 0)} views</span>
                </div>
              </div>
            </Link>
          </li>
        );
      })}
    </>
  );
};

export default BlogList;
